import Vue from 'vue';
import * as VueFactory from 'Models/utils/vue-factory';
import * as ComponentParser from 'Models/utils/component-parser';

// Define static components
import icon from 'Components/vue/icon';

// Register static components
Vue.component('icon', icon);

// Define async components
const asyncComponents = [
    'search',
    'search-results',
    'search-suggestions',
];

// Register async components
asyncComponents.forEach(asyncComponent => {
    Vue.component(asyncComponent, () => import(/* webpackChunkName: "[request]" */ `Components/vue/${asyncComponent}`));
});

ComponentParser.registerFactory('vue', VueFactory.create);
